<template>
  <div class="finale" v-if="userData">
    <div class="content">
      <img class="finale__bird" src="../assets/images/bird.gif">
      <h1>{{ stationData.danke_title }}</h1>
      <p v-bind:class="{ visible: showText }">{{ stationData.finale_text }}</p>
      <img
        class="hero__birdlife"
        :src="
          $i18n.locale == 'de'
            ? require('../assets/images/birdlife-de.svg')
            : require('../assets/images/birdlife-fr.svg')
        "
        alt="BirdLife Schweiz"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Finale',
  props: ['userData', 'stationData'],
  mounted() {
    this.initAudio();
  },
  data: () => {
    return {
      showText: false
    }
  },
  methods: {
    initAudio() {
      this.soundVoice = new Howl({
        src: [this.stationData.outro_text],
        autoplay: true
      });
      this.soundVoice.on('end', () => {
        this.showText = true;
      });
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">

.finale {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;  
  background-color: var(--white);
}
.finale__bird {
  display: block;
  margin-bottom: 2rem;
  width: 250px;
  height: 200px;
  opacity: 0;
  animation: fadein 2s linear .5s 1 forwards;
}
.finale__birdlife {
  position: absolute;
  bottom: 6rem;
  left: 0;
  width: 100%;
  height: 5rem;
  object-fit: contain;
}
.content {
  height: 100%;
  padding: 6rem;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}
h1 {
  font-size: 2.5rem;
  text-align: center;
  line-height: 1.3;
  margin: 0;
  opacity: 0;
  animation: fadein 2s linear .5s 1 forwards;
}
p {
  font-size: 1.1rem;
  max-width: 34rem;
  font-family: 'Syntax';
  text-align: center;
  opacity: 0;
  transition: 1s opacity;
  
  &.visible {
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

</style>
